<template>
  <div v-if="loadMore?.visible" class="sb-minibrowser__load-more">
    <SbSkeleton v-if="loadMore.loading" height="40px" />

    <template v-else>
      <p class="sb-minibrowser__load-more-text">
        You've viewed {{ loadMore.current }} out of {{ loadMore.total }} items
      </p>
      <SbButton
        variant="secondary"
        size="medium"
        label="Load more"
        is-full-width
        :is-disabled="context.isLoading"
        @click="handleLoadMore"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SbButton from '../../Button'
import { useMinibrowser } from '../utils'
import SbSkeleton from '../../Skeleton/SbSkeleton.vue'

const { context } = useMinibrowser()

const loadMore = computed(() => context.value.loadMore)
const handleLoadMore = () => {
  context.value.loadMoreItems()
}
</script>
